module.exports = __webpack_public_path__ + "static/media/p2_s4.07382d53.ogg";